module.exports = __webpack_public_path__ + "media/of_busy_city_days.08ed3d9c.ogg";